<script>
import EditView from "@/components/operations/Edit";

export default {
  extends: EditView,
  data() {
    return {
      settings: {
        module: "Coordenador",
        subModuleTitle: "Supervisores",
        subModule: "Supervisores",
        route: "/operacional/coordenador",
        listApi: "v1/user/coordinator",
        roleToAdd: "supervisor"
      }
    };
  }
};
</script>
